module.exports = __webpack_public_path__ + "img/user_profile.847508d7.png";